<button
  mat-button
  (keydown.enter)="$event.preventDefault()"
  (keyup.enter)="close.emit(false)"
  (click)="close.emit(false)"
  id="close-button"
>
  <mat-icon id="close-button">cancel</mat-icon>
</button>

<header class="ta-c">
  <h1>Update License Plate</h1>
</header>

<main class="pwa-5 pwt-5 as-ctr fs-u1 ta-c">
  Hmm, we seem to have hit a bump in the road. We don't have your license plate.
</main>

<footer class="qq-buttons fld-col ai-ctr">
  <button
    mat-raised-button
    color="primary"
    class="mwb-3 add-btn"
    (click)="close.emit(true)"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="close.emit(true)"
  >
    Update
  </button>
  <button
    mat-raised-button
    (click)="close.emit(false)"
    (keydown.enter)="$event.preventDefault()"
    (keyup.enter)="close.emit(false)"
  >
    Cancel
  </button>
</footer>
